import { FecharTooltipView } from "./view-fechar-tooltip";
import type { FecharTooltipProps } from "./types-fechar-tooltip";

export function FecharTooltip(props: FecharTooltipProps) {
  return <FecharTooltipView {...props} />;
}

export { fecharPt } from "./fechar-tooltip.constants";
export type * from "./types-fechar-tooltip";
